import { render, staticRenderFns } from "./DrawerTeamMembersDetails.vue?vue&type=template&id=4f2a4444"
import script from "./DrawerTeamMembersDetails.vue?vue&type=script&lang=js"
export * from "./DrawerTeamMembersDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports